package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.LightbulbW500Rounded: ImageVector
    get() {
        if (_lightbulbW500Rounded != null) {
            return _lightbulbW500Rounded!!
        }
        _lightbulbW500Rounded = Builder(name = "LightbulbW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(421.47f, 869.53f)
                quadToRelative(-24.34f, -25.05f, -24.34f, -60.68f)
                horizontalLineToRelative(165.74f)
                quadToRelative(0.0f, 35.63f, -24.35f, 60.68f)
                quadToRelative(-24.34f, 25.06f, -58.53f, 25.06f)
                reflectiveQuadToRelative(-58.52f, -25.06f)
                close()
                moveTo(359.52f, 766.93f)
                quadToRelative(-17.71f, 0.0f, -29.69f, -12.09f)
                quadToRelative(-11.98f, -12.1f, -11.98f, -29.81f)
                quadToRelative(0.0f, -17.72f, 11.98f, -29.7f)
                reflectiveQuadToRelative(29.69f, -11.98f)
                horizontalLineToRelative(240.96f)
                quadToRelative(17.71f, 0.0f, 29.69f, 11.98f)
                reflectiveQuadToRelative(11.98f, 29.7f)
                quadToRelative(0.0f, 17.71f, -11.98f, 29.81f)
                quadToRelative(-11.98f, 12.09f, -29.69f, 12.09f)
                lineTo(359.52f, 766.93f)
                close()
                moveTo(327.85f, 641.43f)
                quadTo(256.7f, 599.0f, 214.28f, 527.97f)
                quadToRelative(-42.41f, -71.04f, -42.41f, -154.67f)
                quadToRelative(0.0f, -128.28f, 89.86f, -218.09f)
                quadToRelative(89.87f, -89.8f, 218.24f, -89.8f)
                quadToRelative(128.38f, 0.0f, 218.27f, 89.8f)
                quadToRelative(89.89f, 89.81f, 89.89f, 218.09f)
                quadToRelative(0.0f, 83.87f, -42.41f, 154.79f)
                quadTo(703.3f, 599.0f, 632.15f, 641.43f)
                horizontalLineToRelative(-304.3f)
                close()
                moveTo(355.2f, 550.43f)
                horizontalLineToRelative(249.6f)
                quadToRelative(44.29f, -31.52f, 68.31f, -77.56f)
                quadToRelative(24.02f, -46.04f, 24.02f, -99.51f)
                quadToRelative(0.0f, -91.1f, -63.04f, -154.02f)
                quadToRelative(-63.05f, -62.93f, -154.09f, -62.93f)
                reflectiveQuadToRelative(-154.09f, 62.93f)
                quadToRelative(-63.04f, 62.92f, -63.04f, 154.02f)
                quadToRelative(0.0f, 53.47f, 24.02f, 99.51f)
                quadToRelative(24.02f, 46.04f, 68.31f, 77.56f)
                close()
                moveTo(480.0f, 550.43f)
                close()
            }
        }
        .build()
        return _lightbulbW500Rounded!!
    }

private var _lightbulbW500Rounded: ImageVector? = null
